import React from 'react';
import {startWith} from 'rxjs/operators';

import {getForm, searchForms} from 'iss/service/FormService';
import {SubscribeTo} from 'iss/utils/subscriptionUtils';
import {CollapsibleButtonPanel} from 'iss/widgets/Panels';
import {SearchableSelector} from 'iss/widgets/selectors/SearchableSelector';

/*
 * EvaluationFormSelector is a searchable selector of evaluation forms, with
 * found forms shown as button panel and selected form having a headings and
 * questions preview. Used in batch activation.
 */
export function EvaluationFormSelector({filter, context, ...props}) {
  function getForms(query, page, pageSize) {
    return searchForms({query, context}, page, pageSize, filter);
  }

  function showSelected(form) {
    return <FormPreview form={form} />;
  }

  return <SearchableSelector getItems={getForms}
    {...props} selectedItemFormatter={showSelected}>
    {form => [
        <strong key="name">{form.name}</strong>,
        <div key="addr">{form.description}</div>
    ]}
    </SearchableSelector>;
}

function FormPreview({form}) {
  const formObservable = getForm(form.id, {showLoadingScreen: false}).pipe(startWith(form));

  return <SubscribeTo observable={formObservable} errorHandler={() => form.name}>
    {(form) =>
      <CollapsibleButtonPanel buttonText={form.name}>
        <div className="well well-sm">
          {(form.headings || []).map((heading) =>
            <CollapsibleButtonPanel key={heading.id} buttonText={heading.title}>
              <ul>
                {heading.questions.map((question) =>
                  <li key={question.id}>{question.name}</li>
                )}
              </ul>
            </CollapsibleButtonPanel>
          )}
        </div>
      </CollapsibleButtonPanel>
    }
  </SubscribeTo>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/selectors/EvaluationFormSelector.jsx